import React from 'react';
import { fmtDateTime } from './constants';
import { StatusBadge, StatusSelect } from './shared';

const LeadsTab = ({ leads, onUpdateStatus }) => (
  <div className="bg-white border border-black/5 overflow-x-auto" data-testid="leads-tab">
    <table className="w-full text-[13px]">
      <thead>
        <tr className="text-left text-[10px] tracking-[0.22em] text-[#6b6b6b] border-b border-black/10">
          <th className="px-4 py-3 font-semibold">COMPANY</th>
          <th className="px-4 py-3 font-semibold">CONTACT</th>
          <th className="px-4 py-3 font-semibold">EMAIL</th>
          <th className="px-4 py-3 font-semibold">TEAM SIZE</th>
          <th className="px-4 py-3 font-semibold">MESSAGE</th>
          <th className="px-4 py-3 font-semibold">RECEIVED</th>
          <th className="px-4 py-3 font-semibold">STATUS</th>
        </tr>
      </thead>
      <tbody>
        {leads.length === 0 && (
          <tr><td colSpan={7} className="text-center text-[#6b6b6b] py-10">No corporate leads yet.</td></tr>
        )}
        {leads.map((l) => (
          <tr key={l.id} className="border-b border-black/5 hover:bg-[#faf6f0]/60" data-testid={`lead-row-${l.id}`}>
            <td className="px-4 py-3 font-semibold text-[#1c1e20]">{l.company}</td>
            <td className="px-4 py-3 text-[#3c3c3c]">{l.name}</td>
            <td className="px-4 py-3 text-[#3c3c3c]">
              <a href={`mailto:${l.email}`} className="hover:text-[#c9a961]">{l.email}</a>
            </td>
            <td className="px-4 py-3 text-[#3c3c3c]">{l.size || '—'}</td>
            <td className="px-4 py-3 text-[#6b6b6b] text-[12px] max-w-[280px]">
              <span className="line-clamp-2">{l.message || '—'}</span>
            </td>
            <td className="px-4 py-3 text-[#6b6b6b] text-[12px]">{fmtDateTime(l.created_at)}</td>
            <td className="px-4 py-3">
              <div className="flex flex-col gap-1.5">
                <StatusBadge value={l.status} />
                <StatusSelect
                  value={l.status}
                  onChange={(s) => onUpdateStatus(l.id, s)}
                  testId={`lead-status-select-${l.id}`}
                />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default LeadsTab;
